import { IsoCountryCode2 } from '@rbilabs/intl';

import { useLocale } from 'state/intl';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

export const useCountryStoreRestrictions = () => {
  const { region } = useLocale();
  const countryStoreRestrictionFlag =
    useFlag<keyof typeof IsoCountryCode2 | 'auto'>(
      LaunchDarklyFlag.ENABLE_OVERRIDE_COUNTRY_STORE_RESTRICTION
    ) || 'auto';

  const getCountryStoreRestriction = () => {
    return countryStoreRestrictionFlag === 'auto' ? region : countryStoreRestrictionFlag;
  };

  return { getCountryStoreRestriction };
};
